
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M12.957 24c-6.598 0-12-5.358-12-12 0-6.598 5.402-12 12-12s12 5.402 12 12c0 6.642-5.358 12-12 12zm4.074-16.87a.888.888 0 00-.886.885c0 .487.399.885.886.885a.888.888 0 00.885-.885.888.888 0 00-.885-.886zm-3.985 1.15c-2.037 0-3.72 1.683-3.72 3.72s1.683 3.72 3.72 3.72 3.72-1.683 3.72-3.72a3.713 3.713 0 00-3.72-3.72zm0 6.111A2.381 2.381 0 0110.654 12a2.381 2.381 0 012.392-2.391A2.381 2.381 0 0115.436 12a2.381 2.381 0 01-2.39 2.391zm7.527-5.49a4.554 4.554 0 00-4.56-4.562h-5.979A4.554 4.554 0 005.474 8.9v6.022a4.554 4.554 0 004.56 4.561h6.023a4.554 4.554 0 004.56-4.56V8.9h-.044zm-1.417 6.021a3.156 3.156 0 01-3.144 3.144h-5.978a3.156 3.156 0 01-3.143-3.143V8.9a3.156 3.156 0 013.143-3.144h6.023A3.156 3.156 0 0119.2 8.9v6.022h-.045z"}})])
          )
        }
      }
    